export const groupParamsByKey = (params: URLSearchParams) => {
    return [...params.entries()].reduce((acc: { [key: string]: string[] | string }, [key, val]) => {
        if (acc.hasOwnProperty(key)) {
            Array.isArray(acc[key]) ? (acc[key] as string[]).push(val) : (acc[key] = [acc[key] as string, val])
        } else {
            acc[key] = val
        }

        return acc
    }, {})
}
